import { create } from "zustand";

import proxy from "api/proxy";

const useGlobal = create((set, get) => ({
  countries: [],
  subdivisionsCache: {},
  citiesCache: {},
  customStore: {},
  setCustomStore: (data) => set(() => ({ customStore: data })),
  loadData: async () => {
    const fieldsCountry = ["id", "name", "code"];
    const { data: countries } = await proxy.search(
      "country.country",
      [],
      fieldsCountry,
    );
    set(() => ({ countries }));
  },
  fetchSubdivisions: async (countryId) => {
    if (!countryId) return;
    const { subdivisionsCache } = get();
    if (subdivisionsCache[countryId]) return;

    const fieldsSub = ["id", "name", "country"];
    const { data: subdivisions } = await proxy.search(
      "country.subdivision",
      [["country", "=", countryId]],
      fieldsSub,
    );

    set((state) => ({
      subdivisionsCache: {
        ...state.subdivisionsCache,
        [countryId]: subdivisions,
      },
    }));
  },
  fetchCities: async (subdivisionId) => {
    if (!subdivisionId) return;
    const { citiesCache } = get();
    if (citiesCache[subdivisionId]) return;

    const fieldsCity = ["id", "name", "subdivision"];
    const { data: cities } = await proxy.search(
      "country.city",
      [["subdivision", "=", subdivisionId]],
      fieldsCity,
    );

    set((state) => ({
      citiesCache: {
        ...state.citiesCache,
        [subdivisionId]: cities,
      },
    }));
  },
}));

export { useGlobal };
